/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import { slug } from '../../../common';
const t = function () {
  return app.translator.trans(...arguments);
};
const prfx = `${slug}.forum.user`;
export default class ExpPoints extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }
  view() {
    const expEnabled = app.forum.attribute(`${slug}.exp.enabled`);
    const expShow = app.forum.attribute(`${slug}.exp.show`);
    if (!expEnabled || !expShow) {
      return null;
    }
    const {
      user
    } = this.attrs;
    return m("div", {
      className: "ExpPoints"
    }, t(`${prfx}.points`, {
      points: user.exp()
    }));
  }
}
flarum.reg.add('glowingblue-gamilytics', 'forum/expPoints/components/ExpPoints', ExpPoints);